import Vue from "vue";
import VueRouter from "vue-router";
import Layout from "@/components/Navigation/index.vue";
// import Layout from "@/components/Navigation/ceshi2.vue";
import Layout2 from "@/components/Navigation2/index.vue";
Vue.use(VueRouter);
const routes = [
  {
    path: "/",
    name: "/",
    redirect: "/signin",
  },
  {
    path: "/module",
    name: "module",
    component: Layout,
    redirect: "/module/home",
    children: [
      {
        path: "home",
        name: "home",
        component: () => import("@/views/module/home"),
        meta: { title: "工作平台" },
      },
      {
        path: "message",
        component: () => import("@/views/module/message"),
        meta: { title: "消息管理" },
      },
      {
        path: "procedure",
        component: () => import("@/views/module/procedure"),
        meta: { title: "审批流管理" },
      },
      {
        path: "examine1",
        component: () => import("@/views/module/examine1"),
        meta: { title: "待办" },
      },
      {
        path: "examine2",
        component: () => import("@/views/module/examine2"),
        meta: { title: "已办" },
      },
      {
        path: "examine3",
        component: () => import("@/views/module/examine3"),
        meta: { title: "被退回" },
      },
      {
        path: "examine4",
        component: () => import("@/views/module/examine4"),
        meta: { title: "办结" },
      },
      {
        path: "consult",
        component: () => import("@/views/module/consult"),
        meta: { title: "待我阅知" },
      },
      {
        path: "rights",
        component: () => import("@/views/module/rights"),
        meta: { title: "权限配置" },
      },
      {
        path: "systemRoleMessageSubscription",
        component: () => import("@/views/module/systemRoleMessageSubscription"),
        meta: { title: "通知订阅" },
      },
      {
        path: "roles",
        component: () => import("@/views/module/roles"),
        meta: { title: "角色管理" },
      },
      {
        path: "system",
        component: () => import("@/views/module/system"),
        meta: { title: "系统模块" },
      },
      {
        path: "project",
        component: () => import("@/views/module/project"),
        meta: { title: "项目" },
      },
      {
        path: "company",
        component: () => import("@/views/module/company"),
        meta: { title: "单位" },
      },
      {
        path: "department",
        component: () => import("@/views/module/department"),
        meta: { title: "部门" },
      },
      {
        path: "organization",
        component: () => import("@/views/module/organization"),
        meta: { title: "组织关系" },
      },
      {
        path: "position",
        component: () => import("@/views/module/position"),
        meta: { title: "岗位目录" },
      },
      {
        path: "costCenter",
        component: () => import("@/views/module/costCenter"),
        meta: { title: "成本中心" },
      },
      {
        path: "manpower",
        component: () => import("@/views/module/manpower"),
        meta: { title: "人力资源招聘审批" },
      },
      {
        path: "manpowerRequestAccounting",
        component: () => import("@/views/module/manpowerRequestAccounting"),
        meta: { title: "人力需求协调配置情况" },
      },
      {
        path: "outsourcingApproval",
        component: () => import("@/views/module/outsourcingApproval"),
        meta: { title: "外包单位引入审批" },
      },
      {
        path: "oInformation",
        component: () => import("@/views/module/oInformation"),
        meta: { title: "外包人员指导价审批" },
      },
      {
        path: "leave",
        component: () => import("@/views/module/leave"),
        meta: { title: "病事假审批" },
      },
      {
        path: "leaveWelfare",
        component: () => import("@/views/module/leaveWelfare"),
        meta: { title: "福利假审批" },
      },
      {
        path: "overtime",
        component: () => import("@/views/module/overtime"),
        meta: { title: "加班审批" },
      },
      {
        path: "vacation",
        component: () => import("@/views/module/vacation"),
        meta: { title: "休假" },
      },
      {
        path: "cost1",
        component: () => import("@/views/module/cost1"),
        meta: { title: "沙化费用分割审批" },
      },
      {
        path: "cost2",
        component: () => import("@/views/module/cost2"),
        meta: { title: "沙特籍培训费用分割审批" },
      },
      {
        path: "cost3",
        component: () => import("@/views/module/cost3"),
        meta: { title: "HRDF返还费用审批" },
      },
      {
        path: "costChilden1",
        component: () => import("@/views/module/costChilden1"),
        meta: { title: "成本统计" },
      },
      {
        path: "costChilden2",
        component: () => import("@/views/module/costChilden2"),
        meta: { title: "沙特籍培训费用" },
      },
      {
        path: "costChilden3",
        component: () => import("@/views/module/costChilden3"),
        meta: { title: "HRDF返还费用" },
      },
      {
        path: "journal",
        component: () => import("@/views/module/journal"),
        meta: { title: "系统日志" },
      },
      {
        path: "mail",
        component: () => import("@/views/module/mail"),
        meta: { title: "站内信" },
      },
      {
        path: "visaApproval",
        component: () => import("@/views/module/visaApproval"),
        meta: { title: "员工签证使用审批" },
      },
      {
        path: "statisticalLedger",
        component: () => import("@/views/module/statisticalLedger"),
        meta: { title: "员工签证审批台账" },
      },
      {
        path: "visitInvitationLetter",
        component: () => import("@/views/module/visitInvitationLetter"),
        meta: { title: "家庭访签邀请函审批" },
      },
      {
        path: "planeTicket",
        component: () => import("@/views/module/planeTicket"),
        meta: { title: "人员撤离审批" },
      },
      {
        path: "government",
        component: () => import("@/views/module/government"),
        meta: { title: "政府授权" },
      },
      {
        path: "institutionalQualifications",
        component: () => import("@/views/module/institutionalQualifications"),
        meta: { title: "机构资质" },
      },
      {
        path: "invite",
        component: () => import("@/views/module/invite"),
        meta: { title: "访问签证邀请函审批" },
      },
      {
        path: "news",
        component: () => import("@/views/module/news"),
        meta: { title: "网站公告" },
      },
      {
        path: "changeApplication",
        component: () => import("@/views/module/changeApplication"),
        meta: { title: "人员信息修改审批" },
      },
      {
        path: "outsourcingPo",
        component: () => import("@/views/module/outsourcingPo"),
        meta: { title: "服务外包PO签发" },
      },
      {
        path: "ticketPurchase",
        component: () => import("@/views/module/ticketPurchase"),
        meta: { title: "机票请购审批" },
      },
      {
        path: "ticketChange",
        component: () => import("@/views/module/ticketChange"),
        meta: { title: "机票变更审批" },
      },
      {
        path: "transferStation",
        component: () => import("@/views/module/transferStation"),
        meta: { title: "接送站信息" },
      },
      {
        path: "transferStation",
        component: () => import("@/views/module/transferStation"),
        meta: { title: "接送站信息" },
      },
      {
        path: "splitAirfareCosts",
        component: () => import("@/views/module/splitAirfareCosts"),
        meta: { title: "机票费用分割审批" },
      },
      {
        path: "NewTicketingAgentApplication",
        component: () => import("@/views/module/NewTicketingAgentApplication"),
        meta: { title: "票代引入审批" },
      },
      {
        path: "ticketingAgent",
        component: () => import("@/views/module/TicketingAgent"),
        meta: { title: "票代资源库管理" },
      },
      {
        path: "ticketingAgentTable",
        component: () => import("@/views/module/TicketingAgentTable"),
        meta: { title: "票务代理档案管理表单页" },
      },

      {
        path: "blacklist",
        component: () => import("@/views/module/blacklist"),
        meta: { title: "不良人员" },
      },
      {
        path: "ticketBooking",
        component: () => import("@/views/module/ticketBooking"),
        meta: { title: "机票订购管理" },
      },
      {
        path: "SHICost",
        component: () => import("@/views/module/SHICost"),
        meta: { title: "医保费用分割审批" },
      },
      {
        path: "GOSICost",
        component: () => import("@/views/module/GOSICost"),
        meta: { title: "GOSI费用分割审批" },
      },
      {
        path: "EOSBCost",
        component: () => import("@/views/module/EOSBCost"),
        meta: { title: "EOSB费用计提审批" },
      },
      {
        path: "oufm",
        component: () => import("@/views/module/oufm"),
        meta: { title: "外包单位资源库" },
      },
      {
        path: "oufmTable",
        component: () => import("@/views/module/oufmTable"),
        meta: { title: "外包档案管理表单页" },
      },
      {
        path: "oufmkh",
        component: () => import("@/views/module/oufmkh"),
        meta: { title: "外包考核管理" },
      },
      {
        path: "oufmjc",
        component: () => import("@/views/module/oufmjc"),
        meta: { title: "外包奖惩管理" },
      },
      {
        path: "ljsoo",
        component: () => import("@/views/module/ljsoo"),
        meta: { title: "外包单位订单审批" },
      },
      {
        path: "ljsoosjk",
        component: () => import("@/views/module/ljsoosjk"),
        meta: { title: "外包单位订单台账" },
      },
      {
        path: "jobCategory",
        component: () => import("@/views/module/jobCategory"),
        meta: { title: "岗位类别" },
      },
      {
        path: "saudizationGroup",
        component: () => import("@/views/module/saudizationGroup"),
        meta: { title: "岗位沙化分类" },
      },
      {
        path: "positionLevel",
        component: () => import("@/views/module/positionLevel"),
        meta: { title: "岗位层级" },
      },
      {
        path: "ticketAirfare",
        component: () => import("@/views/module/ticketAirfare"),
        meta: { title: "机票信息台账" },
      },
      {
        path: "monthlyCredit",
        component: () => import("@/views/module/monthlyCredit"),
        meta: { title: "月度挂账" },
      },
      {
        path: "manpowerSupplierMonthlyCost",
        component: () => import("@/views/module/manpowerSupplierMonthlyCost"),
        meta: { title: "月度挂账审批" },
      },

      {
        path: "monthlyCreditManagement",
        component: () => import("@/views/module/monthlyCreditManagement"),
        meta: { title: "外包单位费用台账" },
      },
      {
        path: "outsourcingFee",
        component: () => import("@/views/module/outsourcingFee"),
        meta: { title: "外包人员费用台账" },
      },
      {
        path: "flightPath",
        component: () => import("@/views/module/flightPath"),
        meta: { title: "飞行路线管理" },
      },
      {
        path: "NARManagement",
        component: () => import("@/views/module/NARManagement"),
        meta: { title: "目的地国家管理" },
      },
      {
        path: "urbanManagement",
        component: () => import("@/views/module/urbanManagement"),
        meta: { title: "目的地城市管理" },
      },
      {
        path: "internalBorrowingAgreement",
        component: () => import("@/views/module/internalBorrowingAgreement"),
        meta: { title: "内部借工审批" },
      },
      {
        path: "overseasMission",
        component: () => import("@/views/module/overseasMission"),
        meta: { title: "因公临时出境任务审批" },
      },
      {
        path: "overseasPublicSafetyTraining",
        component: () => import("@/views/module/overseasPublicSafetyTraining"),
        meta: { title: "公共安全培训审批" },
      },
      {
        path: "internalBorrowingAgreementCost",
        component: () =>
          import("@/views/module/internalBorrowingAgreementCost"),
        meta: { title: "内部借工费用分割审批" },
      },
      {
        path: "monthlyCreditDetails",
        component: () => import("@/views/module/monthlyCreditDetails"),
        meta: { title: "当地岗位服务费月度挂账明细" },
      },
      {
        path: "sponsorChange",
        component: () => import("@/views/module/sponsorChange"),
        meta: { title: "雇员转保" },
      },
      {
        path: "overseasPublicSafetyTrainingLedger",
        component: () =>
          import("@/views/module/overseasPublicSafetyTrainingLedger"),
        meta: { title: "公共安全培训台账" },
      },
      {
        path: "RecordforVisa",
        component: () => import("@/views/module/RecordforVisa"),
        meta: { title: "工作签证状态跟踪" },
      },
      {
        path: "RecordforVisa1",
        component: () => import("@/views/module/RecordforVisa1"),
        meta: { title: "访问签证状态跟踪" },
      },
      {
        path: "VisaRecordofBusiness1",
        component: () => import("@/views/module/VisaRecordofBusiness1"),
        meta: { title: "第三国签证状态跟踪" },
      },

      {
        path: "VisaRecordofBusiness2",
        component: () => import("@/views/module/VisaRecordofBusiness2"),
        meta: { title: "单次往返签证" },
      },
      {
        path: "VisaRecordofBusiness3",
        component: () => import("@/views/module/VisaRecordofBusiness3"),
        meta: { title: "多次往返签证" },
      },
      {
        path: "VisaRecordofBusiness4",
        component: () => import("@/views/module/VisaRecordofBusiness4"),
        meta: { title: "往返签证延期" },
      },
      {
        path: "VisaRecordofBusiness5",
        component: () => import("@/views/module/VisaRecordofBusiness5"),
        meta: { title: "离境签证" },
      },
      {
        path: "visaWarning",
        component: () => import("@/views/module/visaWarning"),
        meta: { title: "签证预警管理" },
      },
      {
        path: "feedbacks",
        component: () => import("@/views/module/feedbacks"),
        meta: { title: "问题反馈" },
      },
      {
        path: "foreignVisitsToChina",
        component: () => import("@/views/module/foreignVisitsToChina"),
        meta: { title: "外国人访华业务审批" },
      },
      {
        path: "employeeMedicalInsuranceClassLevel",
        component: () =>
          import("@/views/module/employeeMedicalInsuranceClassLevel"),
        meta: { title: "医保等级标准" },
      },
      {
        path: "employeeMedicalInsuranceRegistration",
        component: () =>
          import("@/views/module/employeeMedicalInsuranceRegistration"),
        meta: { title: "员工医保注册审批" },
      },
      {
        path: "employeeMedicalInsuranceAdjustmentmentApplication",
        component: () =>
          import(
            "@/views/module/employeeMedicalInsuranceAdjustmentmentApplication"
          ),
        meta: { title: "员工医保等级变更审批" },
      },
      {
        path: "employeeMedicalInsuranceRecords",
        component: () =>
          import("@/views/module/employeeMedicalInsuranceRecords"),
        meta: { title: "医保信息台账" },
      },
      {
        path: "overseasWorksApplicationDetail",
        component: () =>
          import("@/views/module/overseasWorksApplicationDetail"),
        meta: { title: "因公临时出境出行情况" },
      },
      {
        path: "Sponsor",
        component: () => import("@/views/module/Sponsor"),
        meta: { title: "当地雇主" },
      },

      {
        path: "workVisaQuotas",
        component: () => import("@/views/module/workVisaQuotas"),
        meta: { title: "工作签证指标管理台账" },
      },
      {
        path: "workVisaQuotaUsageRecords",
        component: () => import("@/views/module/workVisaQuotaUsageRecords"),
        meta: { title: "工作签证指标变动明细" },
      },

      {
        path: "workVisaApplication5",
        component: () => import("@/views/module/workVisaApplication5"),
        meta: { title: "工作签证指标使用计划审批" },
      },
      {
        path: "workVisaApplication1",
        component: () => import("@/views/module/workVisaApplication1"),
        meta: { title: "工作签证指标购买审批" },
      },
      {
        path: "workVisaApplication2",
        component: () => import("@/views/module/workVisaApplication2"),
        meta: { title: "工作签证指标授权审批" },
      },
      {
        path: "workVisaApplication3",
        component: () => import("@/views/module/workVisaApplication3"),
        meta: { title: "工作签证指标取消授权审批" },
      },
      {
        path: "workVisaApplication4",
        component: () => import("@/views/module/workVisaApplication4"),
        meta: { title: "工作签证指标退还记录" },
      },
      {
        path: "positionAdjustmentApplicantion",
        component: () =>
          import("@/views/module/positionAdjustmentApplicantion"),
        meta: { title: "员工岗位变动审批" },
      },
      {
        path: "positionAdjustmentApplicantionOffline",
        component: () =>
          import("@/views/module/positionAdjustmentApplicantionOffline"),
        meta: { title: "员工岗位变动管理" },
      },
      {
        path: "issueNewIqama",
        component: () => import("@/views/module/issueNewIqama"),
        meta: { title: "暂住证办理审批" },
      },
      {
        path: "renewIqama",
        component: () => import("@/views/module/renewIqama"),
        meta: { title: "暂住证延期审批" },
      },
      {
        path: "changeIQAMAProfession",
        component: () => import("@/views/module/changeIQAMAProfession"),
        meta: { title: "暂住证职位更改审批" },
      },
      {
        path: "singleExitReentryVisa",
        component: () => import("@/views/module/singleExitReentryVisa"),
        meta: { title: "单次往返签证办理审批" },
      },
      {
        path: "multipleExitReentryVisa",
        component: () => import("@/views/module/multipleExitReentryVisa"),
        meta: { title: "多次往返签证办理审批" },
      },
      {
        path: "extendExitReentryVisa",
        component: () => import("@/views/module/extendExitReentryVisa"),
        meta: { title: "往返签证延期审批" },
      },
      {
        path: "issueBusniessVisitVisa",
        component: () => import("@/views/module/issueBusniessVisitVisa"),
        meta: { title: "商务访签办理" },
      },
      {
        path: "busniessVisitVisaExtension",
        component: () => import("@/views/module/busniessVisitVisaExtension"),
        meta: { title: "商务访签延期审批" },
      },
      {
        path: "issueWorkingVisitVisa",
        component: () => import("@/views/module/issueWorkingVisitVisa"),
        meta: { title: "工作访签办理" },
      },
      {
        path: "wrokingVisitVisaExtension",
        component: () => import("@/views/module/wrokingVisitVisaExtension"),
        meta: { title: "工作访签延期" },
      },
      {
        path: "issueTemporaryWorkingVisa",
        component: () => import("@/views/module/issueTemporaryWorkingVisa"),
        meta: { title: "临时工作签证办理" },
      },
      {
        path: "temporaryWrokingVisaExtension",
        component: () => import("@/views/module/temporaryWrokingVisaExtension"),
        meta: { title: "临时工作签证延期审批" },
      },
      {
        path: "thirdCountryVisaApplication",
        component: () => import("@/views/module/thirdCountryVisaApplication"),
        meta: { title: "第三国访问签证办理审批" },
      },
      {
        path: "cancelIQAMA",
        component: () => import("@/views/module/cancelIQAMA"),
        meta: { title: "暂住证注销审批" },
      },
      {
        path: "issueExitVisa",
        component: () => import("@/views/module/issueExitVisa"),
        meta: { title: "离境签证办理审批" },
      },
      {
        path: "ccancelExitVisa",
        component: () => import("@/views/module/ccancelExitVisa"),
        meta: { title: "离境签证注销审批" },
      },
      {
        path: "updatePassport",
        component: () => import("@/views/module/updatePassport"),
        meta: { title: "护照信息更新审批" },
      },
      {
        path: "muqeemSystemApplication",
        component: () => import("@/views/module/muqeemSystemApplication"),
        meta: { title: "其他付费" },
      },
      {
        path: "cancelExitReentry",
        component: () => import("@/views/module/cancelExitReentry"),
        meta: { title: "往返签证注销审批" },
      },
      {
        path: "foreignAffairsCost",
        component: () => import("@/views/module/foreignAffairsCost"),
        meta: { title: "外事费用标准" },
      },
      {
        path: "foreignAffairsPayment",
        component: () => import("@/views/module/foreignAffairsPayment"),
        meta: { title: "外事付费明细" },
      },
      {
        path: "foreignAffairsPaymentSummaryApplicationDetail",
        component: () =>
          import(
            "@/views/module/foreignAffairsPaymentSummaryApplicationDetail"
          ),
        meta: { title: "外事付费明细汇总" },
      },
      {
        path: "foreignAffairsPaymentSummaryApplicationDetailPayments",
        component: () =>
          import(
            "@/views/module/foreignAffairsPaymentSummaryApplicationDetailPayments"
          ),
        meta: { title: "付费明细汇总明细" },
      },
      {
        path: "foreignAffairsPaymentSummaryApplicationDetailcostDivides",
        component: () =>
          import(
            "@/views/module/foreignAffairsPaymentSummaryApplicationDetailcostDivides"
          ),
        meta: { title: "成本分割辅助" },
      },
      {
        path: "foreignAffairsPaymentSummaryApplication",
        component: () =>
          import("@/views/module/foreignAffairsPaymentSummaryApplication"),
        meta: { title: "外事付费审批" },
      },
      {
        path: "foreignAffairsAccounting",
        component: () => import("@/views/module/foreignAffairsAccounting"),
        meta: { title: "外事业务台账" },
      },
      {
        path: "employeeInternalTransferOrderApplication",
        component: () =>
          import("@/views/module/employeeInternalTransferOrderApplication"),
        meta: { title: "人员调转审批" },
      },
      {
        path: "employeeInternalTransferOrderAccounting",
        component: () =>
          import("@/views/module/employeeInternalTransferOrderAccounting"),
        meta: { title: "人员调转台账" },
      },
      {
        path: "userPPEDic",
        component: () => import("@/views/module/userPPEDic"),
        meta: { title: "安全帽款式" },
      },
      {
        path: "PPERequestApplication",
        component: () => import("@/views/module/PPERequestApplication"),
        meta: { title: "劳动防护用品申领审批" },
      },
      {
        path: "PPERequestAccounting",
        component: () => import("@/views/module/PPERequestAccounting"),
        meta: { title: "劳保发放台账" },
      },
      {
        path: "userPPE",
        component: () => import("@/views/module/userPPE"),
        meta: { title: "员工劳保信息档案" },
      },
      {
        path: "userPPEDetails",
        component: () => import("@/views/module/userPPEDetails"),
        meta: { title: "员工劳保档案详情" },
      },
      {
        path: "incomeCertificate",
        component: () => import("@/views/module/incomeCertificate"),
        meta: { title: "收入证明" },
      },
      {
        path: "proofEmployment",
        component: () => import("@/views/module/proofEmployment"),
        meta: { title: "工作证明" },
      },
      {
        path: "employmentSeparation",
        component: () => import("@/views/module/employmentSeparation"),
        meta: { title: "离职证明" },
      },
      {
        path: "EmployeeSettlementInfo",
        component: () => import("@/views/module/EmployeeSettlementInfo"),
        meta: { title: "员工社保两金及个税清缴信息" },
      },
      {
        path: "taxClearAll",
        component: () => import("@/views/module/taxClearAll"),
        meta: { title: "员工社保两金及个税清缴通知" },
      },
      {
        path: "employeeMedicalInsurance",
        component: () => import("@/views/module/employeeMedicalInsurance"),
        meta: { title: "员工医保信息管理" },
      },
      {
        path: "employmentForm",
        component: () => import("@/views/module/employmentForm"),
        meta: { title: "用工形式" },
      },
      {
        path: "auxiliaryMaterial",
        component: () => import("@/views/module/auxiliaryMaterial"),
        meta: { title: "劳动防护用品年度计划审批" },
      },
      {
        path: "jobNature",
        component: () => import("@/views/module/jobNature"),
        meta: { title: "岗位性质" },
      },
      {
        path: "trainingCourseApplication",
        component: () => import("@/views/module/trainingCourseApplication"),
        meta: { title: "年度培训班计划审批" },
      },
      {
        path: "trainingCourseAccounting",
        component: () => import("@/views/module/trainingCourseAccounting"),
        meta: { title: "年度培训班台账" },
      },
      {
        path: "employeePersonalAccidentInsuranceRegistration",
        component: () =>
          import(
            "@/views/module/employeePersonalAccidentInsuranceRegistration"
          ),
        meta: { title: "境外保险购买申请" },
      },
      {
        path: "employeeSalaryAdjustment",
        component: () => import("@/views/module/employeeSalaryAdjustment"),
        meta: { title: "员工薪资标准调整审批" },
      },
      {
        path: "PublicSafetyTraining",
        component: () => import("@/views/module/PublicSafetyTraining"),
        meta: { title: "公共安全培训信息管理" },
      },
      {
        path: "employeePersonalAccidentInsurance",
        component: () =>
          import("@/views/module/employeePersonalAccidentInsurance"),
        meta: { title: "境外人保信息管理" },
      },
      {
        path: "EmployeeWorkExperience",
        component: () => import("@/views/module/EmployeeWorkExperience"),
        meta: { title: "员工工作经历" },
      },
      {
        path: "EmploymentContractAccounting",
        component: () => import("@/views/module/EmploymentContractAccounting"),
        meta: { title: "员工合同台账" },
      },
      {
        path: "EmployeeHealthInformationRecord",
        component: () =>
          import("@/views/module/EmployeeHealthInformationRecord"),
        meta: { title: "员工健康档案" },
      },
      {
        path: "EmployeeHealthRiskAssessment",
        component: () => import("@/views/module/EmployeeHealthRiskAssessment"),
        meta: { title: "员工健康风险评估(境外)" },
      },
      {
        path: "EmployeePhysicalExamination",
        component: () => import("@/views/module/EmployeePhysicalExamination"),
        meta: { title: "员工常规体检记录" },
      },
      {
        path: "ticketFareDetail",
        component: () => import("@/views/module/TicketFareDetail"),
        meta: { title: "机票费用明细" },
      },
      {
        path: "ticketFareSummaryApplicationDetail",
        component: () =>
          import("@/views/module/TicketFareSummaryApplicationDetail"),
        meta: { title: "分割单审批" },
      },
      {
        path: "ticketFareSummaryApplicationDetailDetaile",
        component: () =>
          import("@/views/module/TicketFareSummaryApplicationDetailDetaile"),
        meta: { title: "费用明细汇总明细" },
      },

      {
        path: "ticketFareSummaryApplication",
        component: () => import("@/views/module/TicketFareSummaryApplication"),
        meta: { title: "分割单汇总" },
      },
      {
        path: "employeeCareerRecord",
        component: () => import("@/views/module/employeeCareerRecord"),
        meta: { title: "员工履历表" },
      },
      {
        path: "major",
        component: () => import("@/views/module/major"),
        meta: { title: "专业" },
      },
      {
        path: "degree",
        component: () => import("@/views/module/degree"),
        meta: { title: "学位" },
      },
      {
        path: "education",
        component: () => import("@/views/module/education"),
        meta: { title: "学历" },
      },
      {
        path: "school",
        component: () => import("@/views/module/school"),
        meta: { title: "毕业院校" },
      },
      {
        path: "employeeEducationBackground",
        component: () => import("@/views/module/employeeEducationBackground"),
        meta: { title: "教育背景" },
      },
      {
        path: "employeeRewardandPenaltyRecord",
        component: () =>
          import("@/views/module/employeeRewardandPenaltyRecord"),
        meta: { title: "奖惩情况" },
      },
      {
        path: "issueNewDrivingLicense",
        component: () => import("@/views/module/IssueNewDrivingLicense"),
        meta: { title: "当地驾照新办审批" },
      },

      {
        path: "renewDrivingLicenseApplication",
        component: () =>
          import("@/views/module/RenewDrivingLicenseApplication"),
        meta: { title: "当地驾照延期审批" },
      },

      {
        path: "drivingLicense",
        component: () => import("@/views/module/drivingLicense"),
        meta: { title: "驾照信息管理" },
      },
      {
        path: "IQAMA",
        component: () => import("@/views/module/IQAMA"),
        meta: { title: "暂住证信息管理" },
      },
      {
        path: "passport",
        component: () => import("@/views/module/passport"),
        meta: { title: "护照信息管理" },
      },
      {
        path: "employeePersonalAccidentInsuranceCost",
        component: () =>
          import("@/views/module/employeePersonalAccidentInsuranceCost"),
        meta: { title: "人身意外伤害保险费用分割审批" },
      },
      {
        path: "overseasPublicSafetyTrainingCost",
        component: () =>
          import("@/views/module/overseasPublicSafetyTrainingCost"),
        meta: { title: "境外公共安全培训费用分割审批" },
      },
      {
        path: "employeePersonalAccidentInsuranceClaimRecords",
        component: () =>
          import(
            "@/views/module/employeePersonalAccidentInsuranceClaimRecords"
          ),
        meta: { title: "出险记录" },
      },
      {
        path: "EmployeePhysicalExamMetrics",
        component: () => import("@/views/module/EmployeePhysicalExamMetrics"),
        meta: { title: "员工常规体检指数标准" },
      },
      {
        path: "corporation",
        component: () => import("@/views/module/corporation"),
        meta: { title: "公司" },
      },
      {
        path: "insuranceCompany",
        component: () => import("@/views/module/insuranceCompany"),
        meta: { title: "保险公司" },
      },
      {
        path: "governmentPlatform",
        component: () => import("@/views/module/governmentPlatform"),
        meta: { title: "政府平台" },
      },
      {
        path: "companyStakeholderType",
        component: () => import("@/views/module/companyStakeholderType"),
        meta: { title: "干系人管理" },
      },
      {
        path: "departmentType",
        component: () => import("@/views/module/departmentType"),
        meta: { title: "部门属性" },
      },
      {
        path: "orgQualification",
        component: () => import("@/views/module/orgQualification"),
        meta: { title: "企业资质" },
      },
      {
        path: "digitalGovernmentPlatform",
        component: () => import("@/views/module/digitalGovernmentPlatform"),
        meta: { title: "政务平台" },
      },
      {
        path: "positionSubCategory",
        component: () => import("@/views/module/positionSubCategory"),
        meta: { title: "岗位子类别" },
      },
      {
        path: "taskApprovalDocument",
        component: () => import("@/views/module/taskApprovalDocument"),
        meta: { title: "任务批件信息管理" },
      },
      {
        path: "documentConvertAccounting",
        component: () => import("@/views/module/documentConvertAccounting"),
        meta: { title: "外事证照交接记录" },
      },
      {
        path: "handlingForeignAffairs",
        component: () => import("@/views/module/handlingForeignAffairs"),
        meta: { title: "外事业务办理量" },
      },
      {
        path: "chineseEmployeeAttendances",
        component: () => import("@/views/module/chineseEmployeeAttendances"),
        meta: { title: "中国籍非直聘" },
      },
      {
        path: "chineseLocalEmployeeAttendance",
        component: () =>
          import("@/views/module/chineseLocalEmployeeAttendance"),
        meta: { title: "中国籍直聘" },
      },
      {
        path: "foreignEmployeeAttendance",
        component: () => import("@/views/module/foreignEmployeeAttendance"),
        meta: { title: "外籍" },
      },
      {
        path: "ticketFarePaymentSummaryApplication",
        component: () =>
          import("@/views/module/ticketFarePaymentSummaryApplication"),
        meta: { title: "付款通知单审批" },
      },
      {
        path: "ticketFarePaymentSummaryApplicationDetail",
        component: () =>
          import("@/views/module/ticketFarePaymentSummaryApplicationDetail"),
        meta: { title: "费用明细汇总付款单明细" },
      },
      {
        path: "ticketFarePaymentSummary",
        component: () => import("@/views/module/ticketFarePaymentSummary"),
        meta: { title: "付款通知单汇总" },
      },
      {
        path: "ticketStatisticsAnalysis",
        component: () => import("@/views/module/ticketStatisticsAnalysis"),
        meta: { title: "票务统计分析" },
      },
      {
        path: "ticketFareStats1",
        component: () => import("@/views/module/ticketFareStats1"),
        meta: { title: "票价分析1" },
      },
      {
        path: "ticketFareStats2",
        component: () => import("@/views/module/ticketFareStats2"),
        meta: { title: "票价分析2" },
      },
      {
        path: "PersonalInjurySiteGOSIInformationApplication",
        component: () =>
          import("@/views/module/PersonalInjurySiteGOSIInformationApplication"),
        meta: { title: "GOSI工伤报告" },
      },
      {
        path: "PersonalInjurySiteGOSIInformationAccounting",
        component: () =>
          import("@/views/module/PersonalInjurySiteGOSIInformationAccounting"),
        meta: { title: "GOSI理赔台账" },
      },
      {
        path: "employeeSocialInsuranceClassLevel",
        component: () =>
          import("@/views/module/employeeSocialInsuranceClassLevel"),
        meta: { title: "中国籍当地社保等级标准" },
      },
      {
        path: "EmployeeSocialInsurance",
        component: () => import("@/views/module/EmployeeSocialInsurance"),
        meta: { title: "员工社保信息管理" },
      },
      {
        path: "EmployeeWagestoGOSIAppliction1",
        component: () =>
          import("@/views/module/EmployeeWagestoGOSIAppliction1"),
        meta: { title: "员工社保注册审批" },
      },
      {
        path: "EmployeeWagestoGOSIAppliction2",
        component: () =>
          import("@/views/module/EmployeeWagestoGOSIAppliction2"),
        meta: { title: "员工社保变更审批" },
      },
      {
        path: "LeaveRegular",
        component: () => import("@/views/module/LeaveRegular"),
        meta: { title: "定期休假审批" },
      },
      {
        path: "EmployeeLeavePolicy",
        component: () => import("@/views/module/EmployeeLeavePolicy"),
        meta: { title: "定期休假规则" },
      },
      {
        path: "EmployeeLeaveAccounting",
        component: () => import("@/views/module/EmployeeLeaveAccounting"),
        meta: { title: "员工休假台账" },
      },
      {
        path: "CostCategory",
        component: () => import("@/views/module/CostCategory"),
        meta: { title: "费用项目管理" },
      },
      {
        path: "costPoolCategory",
        component: () => import("@/views/module/costPoolCategory"),
        meta: { title: "费用归集管理" },
      },
      {
        path: "costStats",
        component: () => import("@/views/module/costStats"),
        meta: { title: "费用汇总统计" },
      },
      {
        path: "costStatsDetail",
        component: () => import("@/views/module/costStatsDetail"),
        meta: { title: "费用汇总统计明细" },
      },
      {
        path: "userList",
        component: () => import("@/views/module/userList"),
        meta: { title: "基础信息" },
      },
      {
        path: "personnelFile",
        component: () => import("@/views/module/personnelFile"),
        meta: { title: "人员档案" },
      },
      {
        path: "employeeOnboardingInformation",
        component: () => import("@/views/module/employeeOnboardingInformation"),
        meta: { title: "员工入职信息录入审批" },
      },
      {
        path: "employeeQualificationsandCompetence",
        component: () =>
          import("@/views/module/employeeQualificationsandCompetence"),
        meta: { title: "资质信息" },
      },

      {
        path: "JobInfo",
        component: () => import("@/views/module/JobInfo"),
        meta: { title: "工作信息" },
      },
      {
        path: "QualificationsandCompetenceInfo",
        component: () =>
          import("@/views/module/QualificationsandCompetenceInfo"),
        meta: { title: "资格能力" },
      },
      {
        path: "bankAccount",
        component: () => import("@/views/module/bankAccount"),
        meta: { title: "银行账户" },
      },
      {
        path: "foreignAffairInfos",
        component: () => import("@/views/module/foreignAffairInfos"),
        meta: { title: "外事信息" },
      },
      {
        path: "CompensationInfo",
        component: () => import("@/views/module/CompensationInfo"),
        meta: { title: "薪酬信息" },
      },
      {
        path: "CostAccumulation",
        component: () => import("@/views/module/CostAccumulation"),
        meta: { title: "成本归集" },
      },
      {
        path: "employeeInfoChangeRequest",
        component: () => import("@/views/module/employeeInfoChangeRequest"),
        meta: { title: "人员信息修改申请审批" },
      },
      {
        path: "PersonnelBackup",
        component: () => import("@/views/module/PersonnelBackup"),
        meta: { title: "人员备份" },
      },
      {
        path: "personnelFile2",
        component: () => import("@/views/module/personnelFile2"),
        meta: { title: "人员备份档案" },
      },
      {
        path: "CostAggregation",
        component: () => import("@/views/module/CostAggregation"),
        meta: { title: "费用归集" },
      },
      {
        path: "CostMajorCategory",
        component: () => import("@/views/module/CostMajorCategory"),
        meta: { title: "费用大项" },
      },
      {
        path: "CostSubCategory",
        component: () => import("@/views/module/CostSubCategory"),
        meta: { title: "费用子项" },
      },
      {
        path: "CostCategoryDetail",
        component: () => import("@/views/module/CostCategoryDetail"),
        meta: { title: "费用细项" },
      },
      {
        path: "HRWeeklyExternal",
        component: () => import("@/views/module/HRWeeklyExternal"),
        meta: { title: "外部数据采集表" },
      },
      {
        path: "HRWeekly",
        component: () => import("@/views/module/HRWeekly"),
        meta: { title: "人数统计报表" },
      },
      {
        path: "HRWeeklyDetails",
        component: () => import("@/views/module/HRWeeklyDetails"),
        meta: { title: "周报详情" },
      },
      {
        path: "LengthofService",
        component: () => import("@/views/module/LengthofService"),
        meta: { title: "本单位工作年限" },
      },
      {
        path: "ProfessionalTitle",
        component: () => import("@/views/module/ProfessionalTitle"),
        meta: { title: "专业技术资格名称" },
      },
      {
        path: "setPassword",
        component: () => import("@/views/module/setPassword"),
        meta: { title: "修改密码" },
      },
      {
        path: "operation",
        component: () => import("@/views/module/operation"),
        meta: { title: "操作帮助" },
      },
    ],
  },
  {
    path: "/ordinary",
    name: "ordinaryfa",
    component: Layout2,
    redirect: "/ordinary/home",
    children: [
      {
        path: "home",
        name: "ordinary",
        component: () => import("@/views/ordinary/home"),
        meta: { title: "工作平台" },
      },
      {
        path: "leave",
        name: "leave",
        component: () => import("@/views/ordinary/leave"),
        meta: { title: "请假" },
      },
      {
        path: "overtime",
        name: "overtime",
        component: () => import("@/views/ordinary/overtime"),
        meta: { title: "加班" },
      },
      {
        path: "examine",
        name: "examine6",
        component: () => import("@/views/ordinary/examine"),
        meta: { title: "我的申请" },
      },
      {
        path: "systemMessage",
        name: "systemMessage",
        component: () => import("@/views/ordinary/systemMessage"),
        meta: { title: "系统通知" },
      },
      {
        path: "permissions",
        name: "permissions",
        component: () => import("@/views/ordinary/permissions"),
        meta: { title: "404" },
      },
      {
        path: "boxOneBasicInfo",
        name: "boxOneBasicInfo",
        component: () => import("@/views/ordinary/boxOneBasicInfo"),
        meta: { title: "基本信息" },
      },
      {
        path: "boxOneLabor",
        name: "boxOneLabor",
        component: () => import("@/views/ordinary/boxOneLabor"),
        meta: { title: "劳动关系" },
      },
      {
        path: "boxOneSeciality",
        name: "boxOneSeciality",
        component: () => import("@/views/ordinary/boxOneSeciality"),
        meta: { title: "专业技术" },
      },
      {
        path: "boxOneBank",
        name: "boxOneBank",
        component: () => import("@/views/ordinary/boxOneBank"),
        meta: { title: "银行账户" },
      },
      {
        path: "boxOneSalary",
        name: "boxOneSalary",
        component: () => import("@/views/ordinary/boxOneSalary"),
        meta: { title: "人员薪资" },
      },
      {
        path: "boxTwoFreign",
        name: "boxTwoFreign",
        component: () => import("@/views/ordinary/boxTwoFreign"),
        meta: { title: "外事信息" },
      },
      {
        path: "evacuate",
        name: "evacuate",
        component: () => import("@/views/ordinary/evacuate"),
        meta: { title: "撤离" },
      },
      {
        path: "ticketRequisition",
        name: "ticketRequisition",
        component: () => import("@/views/ordinary/ticketRequisition"),
        meta: { title: "机票请购" },
      },
      {
        path: "ticketChange",
        name: "ticketChange",
        component: () => import("@/views/ordinary/ticketChange"),
        meta: { title: "机票变更" },
      },
      {
        path: "payslip",
        name: "payslip",
        component: () => import("@/views/ordinary/Payslip"),
        meta: { title: "工资条" },
      },
      {
        path: "bonus",
        name: "bonus",
        component: () => import("@/views/ordinary/bonus"),
        meta: { title: "奖金" },
      },
      {
        path: "domesticPayments",
        name: "domesticPayments",
        component: () => import("@/views/ordinary/domesticPayments"),
        meta: { title: "国内发放" },
      },
      {
        path: "taxClearAll",
        name: "taxClearAll",
        component: () => import("@/views/ordinary/taxClearAll"),
        meta: { title: "个税清缴" },
      },
      {
        path: "incomeCertificate",
        name: "incomeCertificate",
        component: () => import("@/views/ordinary/IncomeCertificate"),
        meta: { title: "收入证明" },
      },
      {
        path: "positionAdjustmentApplicantion",
        name: "positionAdjustmentApplicantion",
        component: () =>
          import("@/views/ordinary/positionAdjustmentApplicantion"),
        meta: { title: "员工岗位变动" },
      },
      {
        path: "feedbacks",
        name: "feedbacks",
        component: () => import("@/views/ordinary/feedbacks"),
        meta: { title: "问题反馈" },
      },
      {
        path: "proofEmployment",
        name: "proofEmployment",
        component: () => import("@/views/ordinary/proofEmployment"),
        meta: { title: "工作证明" },
      },
      {
        path: "employmentSeparation",
        name: "employmentSeparation",
        component: () => import("@/views/ordinary/employmentSeparation"),
        meta: { title: "离职证明" },
      },
      {
        path: "examine1",
        name: "examine1",
        component: () => import("@/views/ordinary/examine1"),
        meta: { title: "待办" },
      },
      {
        path: "examine2",
        name: "examine2",
        component: () => import("@/views/ordinary/examine2"),
        meta: { title: "已办" },
      },
      {
        path: "examine3",
        name: "examine3",
        component: () => import("@/views/ordinary/examine3"),
        meta: { title: "被退回" },
      },
      {
        path: "examine4",
        name: "examine4",
        component: () => import("@/views/ordinary/examine4"),
        meta: { title: "办结" },
      },
      {
        path: "consult",
        name: "consult",
        component: () => import("@/views/ordinary/consult"),
        meta: { title: "待我查阅" },
      },
      {
        path: "passport",
        name: "passport",
        component: () => import("@/views/ordinary/passport"),
        meta: { title: "护照" },
      },
      {
        path: "IQAMA",
        name: "IQAMA",
        component: () => import("@/views/ordinary/IQAMA"),
        meta: { title: "暂住证" },
      },
      {
        path: "visa",
        name: "visa",
        component: () => import("@/views/ordinary/visa"),
        meta: { title: "签证" },
      },
      {
        path: "setPassword",
        name: "setPassword",
        component: () => import("@/views/ordinary/setPassword"),
        meta: { title: "修改密码" },
      },
    ],
  },
  {
    path: "/personalIncomeTax",
    name: "personalIncomeTax",
    component: () => import("@/views/personalIncomeTax"),
    meta: { title: "个税" },
  },
  {
    path: "/newNavigation",
    name: "newNavigation",
    component: () => import("@/components/Navigation/ceshi2.vue"),
    meta: { title: "测试导航" },
  },
  {
    path: "/exportExcel",
    name: "exportExcel",
    component: () => import("@/views/exportExcel"),
    meta: { title: "生产EXcel" },
  },
  {
    path: "/print",
    name: "print",
    component: () => import("@/views/print.vue"),
    meta: { title: "打印" },
  },
  {
    path: "/print2",
    name: "print2",
    component: () => import("@/views/print2.vue"),
    meta: { title: "打印" },
  },
  {
    path: "/signin",
    name: "signin",
    component: () => import("@/views/signin.vue"),
    meta: { title: "登录" },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

const VueRouterPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch((err) => err);
};

export default router;
